// export const convertToBytes = (sizeString) => {
//   const units = {
//     B: 1,
//     KB: 1024,
//     MB: 1024 * 1024,
//     GB: 1024 * 1024 * 1024,
//   };
//   const [size, unit] = sizeString?.split(/(\d+(?:\.\d+)?)/)?.filter(Boolean);
//   return parseFloat(size) * units[unit.trim()];
// };

export const convertToBytes = (sizeString) => {
  if (!sizeString) return 0;

  const units = { B: 1, KB: 1024, MB: 1024 * 1024, GB: 1024 * 1024 * 1024 };
  const parts = sizeString.split(/(\d+(?:\.\d+)?)/).filter(Boolean);
  const [size, unit] = parts;
  if (size === undefined || !unit) return 0;

  return parseFloat(size) * (units[unit.trim()] || 0);
};

// export const MAX_STORAGE_SIZE = 10 * 1024 * 1024; //100MB
export const MAX_STORAGE_SIZE = 2 * 1024 * 1024 * 1024; //GB

export const convertFromBytes = (bytes) => {
  // Check if bytes is null, undefined, or not a number
  if (bytes === null || isNaN(bytes)) {
    return null; // Or you can return any other message or value you prefer
  }

  if (bytes < 1024) {
    return `${bytes} B`; // Less than 1 KB
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`; // Less than 1 MB
  } else if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`; // Less than 1 GB
  } else {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`; // GB and above
  }
};
